/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

export const SubToolbar = styled.div`
  display: flex;
  position: relative;
  height: 95px;
  width: 100%;
  background: white;
  font-weight: 700;
  padding-left: 0px;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  z-index: 6;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 3em;
  padding-top: 2.25em;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 3.5em;
  left: 0;
  top: 0;
  padding-right: 1em;
  padding-left: 1em;
  color: #4b4b4b;
  font-size: 14;
  line-height: 22px;
  font-style: normal;
  font-weight: 700;
`;

export const Title = styled.p`
  color: #093865;
  font-weight: bold;
  font-size 16px;
  line-height: 26px;
`;

export const UserInfo = styled.span`
  display: flex;
  flex-direction: column;
  font-weight: normal;
  font-weight: 400;
  color: #686868;
`;

export const HeaderTitle = styled.span`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  min-width: 10em;
  color: #4b4b4b;
`;

export const GoBackContainer = styled.span`
  display: flex;
  align-items: start;
  position: absolute;
  z-index: 10;
`;

export const GoBackBtn = styled(NeuButton)`
  margin: 0.25em 0 0 0.1em;
`;
